import React from 'react';

import { CompanyKununuCulture } from '@/graphql/generated';
import { useBreakpoints } from '@/hooks';

import { CultureCompassWrapper } from './culture-compass-wrapper';
import { hasCultureInfo } from './culture-helpers';
import { CultureInfo } from './culture-info';
import { CultureLegend } from './culture-legend';
import { CultureLink } from './culture-link';

import * as S from './culture.styles';

type Props = {
  culture: CompanyKununuCulture;
  companyName: string;
};

export const Culture: React.FC<Props> = ({ culture, companyName }) => {
  const { cultureCompass, link, completedSubmissionsCount } = culture;
  const { isDesktop } = useBreakpoints();

  return (
    <S.StyledCultureColumnsWrapper>
      <S.StyledMobileCultureTitle />
      <S.StyledCompassWithLegend size={!isDesktop ? 12 : 4}>
        <CultureLegend companyNameOverride={companyName} />
        <CultureCompassWrapper size={12} cultureCompass={cultureCompass} />
      </S.StyledCompassWithLegend>
      <S.StyledInfoColumn size={!isDesktop ? 12 : 8}>
        <S.StyledCultureInfoWrapper>
          {hasCultureInfo(cultureCompass, completedSubmissionsCount) ? <S.StyledCultureTitle /> : null}
          <CultureInfo
            companyName={companyName}
            cultureCompass={cultureCompass}
            totalCultureReviews={completedSubmissionsCount}
          />
        </S.StyledCultureInfoWrapper>
        <CultureLink link={link} />
      </S.StyledInfoColumn>
    </S.StyledCultureColumnsWrapper>
  );
};
